/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, useEffect, useState } from 'react';
import { Box, Button, Grid, Modal, Typography } from '@mui/material';
import useStyles from '../../../assets/styles/components/Modals';
import { ReactComponent as IconInfo } from '../../../assets/images/svg/user/info.svg';
import {
  FormatCpf,
  formatCurrencyBR,
  parseCurrencyBRToFloat,
} from '../../../helpers/utils/Formating';

const styleModal = {
  position: 'absolute' as const,
  top: '100%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: '10px 24px',
  outline: 'none',
};

type Props = {
  isOpen: boolean;
  handleFn: (dataInput: string) => Promise<void>;
  onClose: () => void;
  heightModal?: string;
  data: {
    title: string;
    message: string;
    action: number;
    placeholder: string;
    btnConfirm: string;
    btnCancel: string;
    type: string;
    icon: any;
    img: any;
  };
};

const ModalInputFooter = ({
  isOpen,
  handleFn,
  onClose,
  heightModal = '600px',
  data,
}: Props): ReactElement => {
  const classeStyle = useStyles();

  const [openModal, setOpenModal] = useState(isOpen);
  const [dataInput, setDataInput] = useState<any>(null);
  const [formattedPrice, setFormattedPrice] = useState('');

  const closeModal = (): void => {
    setOpenModal(!openModal);
    setDataInput(null);
    setFormattedPrice('');
    onClose();
  };

  const handleSetData = (): void => {
    handleFn(dataInput);
    closeModal();
  };

  const handleNotThing = (): void => {
    handleFn('-1');
    closeModal();
  };

  const handleChangePrice = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const input = e.target.value;
    const onlyNumbers = input.replace(/\D/g, '');

    const formattedValue = formatCurrencyBR(onlyNumbers);
    const numericValue = parseCurrencyBRToFloat(formattedValue);

    setFormattedPrice(formattedValue); // exibição no input
    setDataInput(numericValue); // valor salvo (americano)
  };

  useEffect(() => {
    setOpenModal(isOpen);
  }, [isOpen]);
  return (
    <Modal
      open={openModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...styleModal, height: heightModal }}>
        <Grid container item xs={12} justifyContent="center">
          {data.img ? (
            <img width={35} src={data.img} alt="logo" />
          ) : data.icon ? (
            data.icon
          ) : (
            <IconInfo width={35} height={35} />
          )}
        </Grid>
        <Grid container item xs={12} justifyContent="center">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h4"
            className={classeStyle.titleModal}
            style={{ fontWeight: '550' }}
          >
            {data.title}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2 }}
            className={classeStyle.textModal}
          >
            {data.message}
          </Typography>
          {data.type === 'troco' ? (
            <input
              className={classeStyle.inputText}
              type="text"
              inputMode="numeric"
              pattern="\d*"
              placeholder={data.placeholder}
              value={formattedPrice}
              onChange={handleChangePrice}
            />
          ) : (
            <input
              className={classeStyle.inputText}
              type="text"
              value={FormatCpf(dataInput)}
              placeholder={data.placeholder}
              onChange={(e: { target: { value: string } }) =>
                setDataInput(e.target.value)
              }
            />
          )}
        </Grid>

        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
        >
          <Grid width="80%">
            <Button
              className={classeStyle.btnModal}
              type="submit"
              variant="contained"
              onClick={handleSetData}
            >
              {data.btnConfirm}
            </Button>
            {data.type === 'troco' ? (
              <Grid container item xs={12} justifyContent="center">
                <Button
                  className={classeStyle.btnModalWhite}
                  variant="text"
                  onClick={handleNotThing}
                >
                  <p className={classeStyle.textBtnKeepShopping}>
                    Não preciso de troco
                  </p>
                </Button>
              </Grid>
            ) : data.btnCancel ? (
              <Grid container item xs={12} justifyContent="center">
                <Button
                  className={classeStyle.btnModalWhite}
                  variant="text"
                  onClick={closeModal}
                >
                  <p className={classeStyle.textBtnKeepShopping}>
                    {data.btnCancel}
                  </p>
                </Button>
              </Grid>
            ) : (
              ''
            )}
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ModalInputFooter;
